import './styles/item.css'
export default function Item({ name, description, url }) {
    return (
        <li className="item cursor-detect-hover">
            <a href={url} target='_blank' rel='noreferrer' className="cursor-hoverable">
                <div className="decoration">
                    {name.charAt(0)}
                </div>
                <h1>{name}</h1>
                <div className="description">{description}</div>
            </a>
        </li>
    );
};